import {
    ListenerMiddleware,
    predicateEffect,
    registerPredicateEffect,
} from 'store/listenerMiddleware';
import { selectCurrentSymbology } from 'portfolio/store/selectors';
import State from 'store/State';
import { AnyAction } from 'store/store';
import { createReplaceAllStreamDataPayload } from 'streamsState/store/streamedData/actions';
import { initialStreamedDataState } from 'streamsState/store/streamedData/StreamedDataState';

export const clearStreamedDataOnSymbologyChangeEffect = predicateEffect(
    (action: AnyAction, currentState: State, previousState: State) => {
        const nextSymbology = selectCurrentSymbology(currentState);
        const previousSymbology = selectCurrentSymbology(previousState);
        return nextSymbology !== previousSymbology;
    },
    async (action, api) => {
        const { dispatch } = api;
        dispatch(createReplaceAllStreamDataPayload(initialStreamedDataState));
    }
);

export function registerStreamedDataEffects(middleware: ListenerMiddleware) {
    registerPredicateEffect(
        middleware,
        clearStreamedDataOnSymbologyChangeEffect
    );
}
